import { InjectionToken } from '@angular/core';

export const SHOW_INDICATORS = new InjectionToken<boolean>('config.showIndicators');
export const TRANSLATION_PLATFORM = new InjectionToken<boolean>('config.platform');
